import { isWOA } from '@/infrastructure/auth';
import { OpenCesScene, TogCesScene } from './type';

// 正式调用
const openXmMeterOpenCes = () => {
  if (!isWOA()) return;
  window.xmMeter.openCesScene({
    scene_id: OpenCesScene.scene_id, // CES自定义场景ID
    delay: OpenCesScene.delay, // 可自定义延迟弹窗弹出时间(毫秒)
  });
};


const openXmMeter = (sceneId: string, delay?: number) => {
  if (!isWOA()) return;
  window.xmMeter.openCesScene({
    scene_id: sceneId, // CES自定义场景ID
    delay, // 可自定义延迟弹窗弹出时间(毫秒)
  });
};

// 调试调用(仅验证流程，数据不入库)
const openXmMeterTogCes = () => {
  if (!isWOA()) return;
  window.xmMeter.toggleCesScene({
    scene_id: TogCesScene.scene_id,
    delay: TogCesScene.delay,
  });
};

export  { openXmMeterOpenCes, openXmMeterTogCes, openXmMeter };

